import { omit } from 'lodash/fp';
import { createScopedReducer } from '@mews-commander/utils';
import { OPTION_VALUE_CHANGED, OPTIONS_VALIDATED, OPTION_VALUE_TOUCHED, RESET_SCREEN } from '../actions/types';

export const INITIAL_STATE = {
    values: {
        reservationGroupId: null,
        customerId: null,
        bookerId: null,
        partnerCompanyId: null,
        travelAgencyId: null,
        origin: null,
        state: null,
        releaseDate: '',
        releaseTime: '',
        notes: '',
        confirmationEmailReceivers: null,
        confirmationLanguageCode: null,
    },
    touched: {},
    errors: {},
    allTouched: false,
};

export default createScopedReducer(INITIAL_STATE, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [OPTION_VALUE_CHANGED]: (state, { key, value, error }: $TSFixMe) => ({
        ...state,
        allTouched: state.allTouched,

        values: {
            ...state.values,
            [key]: value,
        },

        errors: {
            ...(error ? { ...state.errors, [key]: error } : omit(key)(state.errors)),
        },
    }),

    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [OPTION_VALUE_TOUCHED]: (state, { key }: $TSFixMe) => ({
        ...state,

        touched: {
            ...state.touched,
            [key]: true,
        },
    }),

    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [OPTIONS_VALIDATED]: (state, errors) => ({
        ...state,
        errors,
        allTouched: true,
    }),

    [RESET_SCREEN]: () => INITIAL_STATE,
});
